var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandidateClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5896 12.4106C13.2641 12.0851 12.7365 12.0851 12.4111 12.4106C12.0856 12.736 12.0856 13.2637 12.4111 13.5891L16.8218 17.9999L12.4111 22.4106C12.0857 22.736 12.0857 23.2637 12.4111 23.5891C12.7365 23.9145 13.2642 23.9145 13.5896 23.5891L18.0003 19.1784L22.4111 23.5891C22.7365 23.9145 23.2641 23.9145 23.5896 23.5891C23.915 23.2637 23.915 22.736 23.5896 22.4106L19.1788 17.9999L23.5896 13.5891C23.915 13.2637 23.915 12.736 23.5896 12.4106C23.2642 12.0851 22.7365 12.0851 22.4111 12.4106L18.0003 16.8213L13.5896 12.4106Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateClose);
export default __webpack_public_path__ + "static/media/candidate-close.198c7f462f8f2900747adc9532a5a5e7.svg";
export { ForwardRef as ReactComponent };